import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { imageService } from '../services';
import Header from './Header';
import { useNavigate } from 'react-router-dom';

const GameGrid = () => {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchGames = async () => {
      try {
        const res = await api.get('/game-reviews/premium', { params: { page: 1, size: 200 } });
        setGames(res?.data?.content || []);
      } catch (err) {
        setError('Không thể tải danh sách game');
      } finally {
        setLoading(false);
      }
    };
    fetchGames();
  }, []);

  if (loading) return <div>Đang tải danh sách game...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;

  return (
    <>
      <Header />
      <div className="game-grid-container">
        <div className="game-grid">
          {games.map((game, idx) => (
            <div
              key={game.slug || idx}
              className={`game-grid-item${game.isPopular ? ' popular' : ''}`}
              style={{ background: '#fff' }}
              onClick={() => game.slug && navigate(`/review-game/${game.slug}`)}
            >
              <div className="game-thumb-wrapper">
                <img
                  src={imageService.getThumbnail(game.thumbnailPath)}
                  alt={game.title}
                  className="game-thumb"
                />
                <span className="game-title-tooltip">{game.title}</span>
              </div>
              {game.isPopular && <span className="popular-badge">POPULAR</span>}
            </div>
          ))}
        </div>
        <style>{`
          .game-grid-container {
            width: 100%;
            max-width: 1600px;
            margin: 0 auto;
            padding: 24px 0;
          }
          .game-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
            gap: 18px;
          }
          .game-grid-item {
            border-radius: 18px;
            overflow: hidden;
            box-shadow: 0 2px 12px 0 rgba(0,0,0,0.07);
            position: relative;
            aspect-ratio: 1/1;
            transition: box-shadow 0.2s, transform 0.2s;
            cursor: pointer;
            background: #f7f7f7;
          }
          .game-grid-item.popular {
            grid-row: span 2;
            grid-column: span 2;
            aspect-ratio: 1/1;
            box-shadow: 0 0 24px 6px rgba(16, 166, 199, 0.25), 0 2px 12px 0 rgba(0,0,0,0.07);
            border: 3px solid #10a6c7;
            animation: glow-popular 1.5s infinite alternate;
            position: relative;
          }
          .game-grid-item.popular:hover {
            transform: scale(1.04);
            box-shadow: 0 0 36px 12px rgba(29, 233, 182, 0.35), 0 8px 32px 0 rgba(16,166,199,0.18);
            z-index: 2;
          }
          @keyframes glow-popular {
            0% { box-shadow: 0 0 16px 2px rgba(16,166,199,0.18), 0 2px 12px 0 rgba(0,0,0,0.07); border-color: #10a6c7; }
            100% { box-shadow: 0 0 36px 12px rgba(29,233,182,0.35), 0 8px 32px 0 rgba(16,166,199,0.18); border-color: #1de9b6; }
          }
          .game-grid-item.popular .popular-badge {
            position: absolute;
            top: 10px;
            right: 10px;
            background: linear-gradient(90deg, #ffc107 60%, #ff9800 100%);
            color: #fff;
            font-size: 0.85rem;
            font-weight: 700;
            padding: 4px 14px;
            border-radius: 16px;
            box-shadow: 0 2px 8px 0 rgba(255,193,7,0.18);
            letter-spacing: 1px;
            z-index: 3;
            pointer-events: none;
            user-select: none;
          }
          .game-thumb-wrapper {
            width: 100%;
            height: 100%;
            position: relative;
          }
          .game-thumb {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 18px;
            display: block;
            transition: filter 0.2s;
          }
          .game-grid-item:hover .game-thumb {
            filter: brightness(0.7) blur(1px);
          }
          .game-title-tooltip {
            position: absolute;
            left: 50%;
            bottom: 10px;
            top: auto;
            transform: translateX(-50%);
            background: rgba(0,0,0,0.8);
            color: #fff;
            padding: 4px 12px;
            border-radius: 8px;
            font-size: 0.95rem;
            font-weight: 500;
            opacity: 0;
            pointer-events: none;
            white-space: pre-line;
            z-index: 2;
            transition: opacity 0.2s;
            text-align: center;
          }
          .game-grid-item:hover .game-title-tooltip {
            opacity: 1;
          }
        `}</style>
      </div>
    </>
  );
};

export default GameGrid; 